var map = {
	"./Accomplishment.png": 1369,
	"./Avatar.png": 1370,
	"./AvatarSmall.png": 1371,
	"./Calendar-VGL-icon.png": 822,
	"./CollapseFilled.png": 972,
	"./Concern.png": 1372,
	"./D6D664D85FEAAD31.png": 1373,
	"./D6D664D85FEAAD32.png": 1374,
	"./GlobalGivingCausesThumb.png": 1090,
	"./Mistake.png": 1375,
	"./NoConcern.png": 1376,
	"./TablePlaceholder.png": 584,
	"./appointments.png": 1377,
	"./biopic.png": 1378,
	"./calendar.png": 1379,
	"./class-duration-icon.png": 1380,
	"./classes.png": 1381,
	"./clients.png": 1382,
	"./dashboard.png": 71,
	"./event-calendar.png": 1100,
	"./excel-icon.png": 1383,
	"./gold-icon.png": 1384,
	"./logo-inner.png": 1385,
	"./logo-watermark.png": 1386,
	"./logo.png": 1387,
	"./mobile-code.png": 1101,
	"./navtest-icon-active.png": 1388,
	"./navtest-icon.png": 1389,
	"./patient-based-icon.png": 1390,
	"./personal.png": 1391,
	"./platinum-icon.png": 1392,
	"./rectangledot-icon-disable.png": 1393,
	"./rectangledot-icon.png": 1394,
	"./reports.png": 1395,
	"./rowimg02.png": 1396,
	"./sales.png": 1397,
	"./silver-icon.png": 1398,
	"./speciality.png": 1399,
	"./staff.png": 975,
	"./summerPolicy.png": 1400,
	"./testicon.png": 1401,
	"./vector-cover-image.png": 1402,
	"./vectorglobal.png": 1403,
	"./vectorgloballogo.png": 1404,
	"./vg-logo.png": 1091,
	"./vgl-blank-image.png": 1405
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1099;